import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import styled from '@emotion/styled';
import { ISO_8601_DATE_FORMAT } from '@model/common';
import { getDealFinderDuration } from '@state/slices/deal-finder/dealFinderSelectors';
import { getCalendarDays } from '@components/price-calendar';
import { Day } from '@components/search/dates/calendar/day-picker/Day';
import { TestId } from '@components/test-ids';

const Container = styled.tbody({
  width: '100%'
});

const Row = styled.tr();

export interface BodyProps {
  day?: string;
  month: moment.Moment;
  onChange: (day: string) => void;
}

export const Body = ({ day, month, onChange }: BodyProps) => {
  const selected: moment.Moment | undefined = day ? moment(day) : undefined;
  const duration = useSelector(getDealFinderDuration);

  return (
    <Container data-testid={TestId.dealFinder.dayPicker.body}>
      {getCalendarDays(moment(month)).map((weekDays: any) => {
        const emptyRow: boolean = weekDays.days.every((day: moment.Moment) => !day.isSame(month, 'month'));
        if (emptyRow) return null;
        return (
          <Row key={weekDays.week}>
            {weekDays.days.map((day: moment.Moment) => (
              <Day
                key={day.format(ISO_8601_DATE_FORMAT)}
                day={day}
                month={month}
                duration={duration}
                selected={selected}
                onClick={onChange}
              />
            ))}
          </Row>
        );
      })}
    </Container>
  );
};
